import { createFileRoute, Link } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";

export const Route = createFileRoute("/evasteet")({
  head: () => ({
    meta: [
      { title: "Evästekäytäntö — Montessori24" },
      { name: "description", content: "Tietoa Montessori24-sivuston käyttämistä evästeistä ja niiden hallinnasta." },
      { property: "og:title", content: "Evästekäytäntö — Montessori24" },
      { property: "og:description", content: "Evästeiden käyttö ja hallinta." },
      { property: "og:url", content: "https://montessori24.fi/evasteet" },
    ],
    links: [{ rel: "canonical", href: "https://montessori24.fi/evasteet" }],
  }),
  component: Cookies,
});

function Cookies() {
  return (
    <Layout>
      <section className="container-prose pt-16 pb-24 md:pt-24">
        <span className="text-xs uppercase tracking-[0.25em] text-muted-foreground">Lakisääteinen</span>
        <h1 className="mt-3 text-5xl text-foreground md:text-6xl text-balance">Evästekäytäntö.</h1>
        <p className="mt-6 max-w-2xl text-muted-foreground">
          Päivitetty 21.5.2026. Käytämme evästeitä (cookies) tarjotaksemme sinulle sujuvan ostokokemuksen ja
          kehittääksemme verkkokauppaa. Tämä sivu kuvaa, mitä evästeitä käytämme ja miten voit hallita niitä.
        </p>

        <div className="mt-12 space-y-10 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          <div>
            <h2 className="text-foreground text-lg">1. Mikä on eväste?</h2>
            <p className="mt-2">
              Eväste on pieni tekstitiedosto, jonka selain tallentaa laitteellesi. Evästeet mahdollistavat sivuston
              perustoiminnot, kuten ostoskorin ja kirjautumisen, sekä auttavat meitä ymmärtämään, miten sivustoa käytetään.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">2. Käyttämämme evästeet</h2>
            <ul className="mt-2 list-disc pl-5 space-y-2">
              <li>
                <strong className="text-foreground">Välttämättömät evästeet</strong> — sivuston toiminnan kannalta
                pakolliset (ostoskori, istunto, tietoturva). Ei vaadi suostumusta.
              </li>
              <li>
                <strong className="text-foreground">Analytiikkaevästeet</strong> — käytetään anonyymin kävijätiedon
                keräämiseen sivuston kehittämiseksi. Vaatii suostumuksen.
              </li>
              <li>
                <strong className="text-foreground">Markkinointievästeet</strong> — käytetään mahdollisesti kohdennetun
                mainonnan näyttämiseen. Vaatii suostumuksen.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-foreground text-lg">3. Evästeiden hallinta</h2>
            <p className="mt-2">
              Voit hyväksyä tai hylätä ei-välttämättömät evästeet evästeilmoituksen kautta. Voit muuttaa valintaasi
              milloin tahansa selaimesi asetuksista tai poistaa tallennetut evästeet. Huomioi, että välttämättömien
              evästeiden estäminen voi rajoittaa sivuston toimintoja.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">4. Lisätietoja</h2>
            <p className="mt-2">
              Henkilötietojen käsittelystä kerromme tarkemmin <Link className="underline" to="/tietosuoja">tietosuojaselosteessa</Link>.
              Kysymyksissä ota yhteyttä:{" "}
              <a className="underline" href="mailto:asiakaspalvelu@montessori24.fi">asiakaspalvelu@montessori24.fi</a>.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
